const genreSelectors = {
  loading: state => state.genreReducer.loading,
  genres: state => state.genreReducer.genres,
  genresOptions: state => {
    const genres = state.genreReducer.genres;
    const genresOptions = Object.values(genres).map(genre => ({ id: genre.id, label: genre.name, value: JSON.stringify(genre) }));
    return genresOptions;
  }
};

export default genreSelectors;